<template>
  <div class="all-loans tw-px-6">
    <div class="back-btn">
      <router-link :to="{ name: 'CreditProvider' }">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.828 7.00017H16V9.00017H3.828L9.192 14.3642L7.778 15.7782L0 8.00017L7.778 0.222168L9.192 1.63617L3.828 7.00017Z"
            fill="#1A2139"
          />
        </svg>
      </router-link>
      <h1>All Loans</h1>
      <CurrencyToggle class="tw-ml-auto" :disabled="isLoading" @change="reload" />
    </div>

    <div v-if="isLoading" class="tw-text-center tw-py-10 tw-text-gray-500">
      Loading loans...
    </div>

    <CreditLoansTable
      v-else
      :loans="loans"
      :subtitle="`${creditPages > 0 ? creditPages : 0} page(s) of loans`"
      :showPagination="true"
      :currentPage="creditPage"
      :totalPages="creditPages"
      @go-to-page="gotoPage"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CurrencyToggle from "@/components/creditProvider/CurrencyToggle.vue";
import CreditLoansTable from "@/components/tables/creditProvider/CreditLoansTable.vue";
import responseHandler from "@/utils/responseHandler.js";

export default {
  name: "AllLoans",
  components: {
    CurrencyToggle,
    CreditLoansTable,
  },
  data() {
    return {
      isLoading: true,
      limit: 10,
    };
  },
  computed: {
    ...mapGetters("organisationModule", ["loans", "creditPage", "creditPages"]),
  },
  created() {
    this.fetchLoans(1);
  },
  methods: {
    ...mapActions("organisationModule", ["getLoans"]),
    async fetchLoans(page) {
      this.isLoading = true;
      try {
        await this.getLoans({ page, limit: this.limit });
      } catch (error) {
        responseHandler.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    // A currency switch changes which rows exist, so page 2 of the old scope is
    // not page 2 of the new one. Back to the first page.
    async reload() {
      await this.fetchLoans(1);
    },

    async gotoPage(page) {
      await this.fetchLoans(page);
    },
  },
};
</script>

<style scoped>
.back-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a2139;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: bold;
}

.back-btn a {
  padding: 10px;
  border-radius: 100%;
  background-color: #d9dce8;
}
</style>
